import React, { Component } from 'react'

import { Link } from 'react-router-dom'

import FlameRed from '../images/flame-red.svg'

class FooterSite extends Component {
  render() {
    return (
      <footer className="footer footer--site">
        <div className="footer__content">
          <span>
            <Link to={`/about`} ><img src={FlameRed} className="media media--flame media--footer-flame"/></Link> Happy camping.
          </span>
          <span>© 2018 <a className="link--subdued" href="https://www.goshortwave.com" target="_blank">Shortwave</a></span>
        </div>
      </footer>
    );
  }
}

export default FooterSite;



// WEBPACK FOOTER //
// ./src/app/components/footers/footer-site.jsx